<mat-card>
  <mat-card-title>
    {{
      '+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.CONFIRMATION_MODAL.HEADER'
        | translate
    }}
  </mat-card-title>
  <mat-card-content class="flex flex-col gap-[20px]">
    <div class="note">
      <b class="warning">{{ 'GENERAL.WARNING' | translate }}: </b>
      <span>{{
        '+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.CONFIRMATION_MODAL.WARNING'
          | translate
      }}</span>
    </div>
    <div>
      {{ 'GENERAL.CHANGE' | translate }}: <b>{{ data.oldValue }}</b> --> <b>{{ data.value }}</b>
    </div>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      data-at-cancel-button
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="flowLimitTempConfirmationDialog"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-deregister-button
      mat-raised-button
      color="primary"
      gtm="onConfirm"
      gtmCategory="flowLimitTempConfirmationDialog"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
